__turbopack_context__.v({
  "bannerContent": "heroBanner-module-scss-module__-J-eUa__bannerContent",
  "betterthatBanner": "heroBanner-module-scss-module__-J-eUa__betterthatBanner",
  "contentWrapper": "heroBanner-module-scss-module__-J-eUa__contentWrapper",
  "imageContent": "heroBanner-module-scss-module__-J-eUa__imageContent",
  "licenSes": "heroBanner-module-scss-module__-J-eUa__licenSes",
  "licenseHolder": "heroBanner-module-scss-module__-J-eUa__licenseHolder",
  "licenseHolders": "heroBanner-module-scss-module__-J-eUa__licenseHolders",
  "licenseInfo": "heroBanner-module-scss-module__-J-eUa__licenseInfo",
  "licensesEnd": "heroBanner-module-scss-module__-J-eUa__licensesEnd",
  "lulaBg": "heroBanner-module-scss-module__-J-eUa__lulaBg",
  "textContent": "heroBanner-module-scss-module__-J-eUa__textContent",
});
